"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var of_1 = require("rxjs/observable/of");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
require("./header-mobile.component.scss");
var user_help_item_model_1 = require("../../models/user-help-item.model");
var HeaderMobileComponent = /** @class */ (function (_super) {
    __extends(HeaderMobileComponent, _super);
    function HeaderMobileComponent(_classifierService, _kbService, _messageService, _eventBase) {
        var _this = _super.call(this) || this;
        _this._classifierService = _classifierService;
        _this._kbService = _kbService;
        _this._messageService = _messageService;
        _this._eventBase = _eventBase;
        _this.isReadonly = false;
        // </editor-fold>
        _this.onWfSelectEvent = new core_1.EventEmitter();
        _this.editClickEvent = new core_1.EventEmitter();
        _this.cancelEvent = new core_1.EventEmitter();
        _this.saveCloseEvent = new core_1.EventEmitter();
        _this._isView = false;
        _this._workflowActions = [];
        // private fields
        _this._title = '';
        return _this;
    }
    Object.defineProperty(HeaderMobileComponent.prototype, "title", {
        // <editor-fold desc="Getters and Setters">
        get: function () {
            return this._title;
        },
        set: function (value) {
            this._title = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "entity", {
        get: function () {
            return this._entity;
        },
        set: function (value) {
            this._entity = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "categoryName", {
        get: function () {
            return this._categoryName;
        },
        set: function (value) {
            this._categoryName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "title_msg", {
        get: function () {
            return this._title_msg;
        },
        set: function (value) {
            this._title_msg = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "isView", {
        get: function () {
            return this._isView !== undefined ? this._isView : this.isReadonly;
        },
        set: function (value) {
            this._isView = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "userHelpItems", {
        get: function () {
            return this._userHelpItems;
        },
        set: function (value) {
            this._userHelpItems = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "userHelpItemsAsObjects", {
        set: function (values) {
            this.userHelpItems = values ? values.map(user_help_item_model_1.userHelpItemFromObject) : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "workflowActions", {
        get: function () {
            return this._workflowActions;
        },
        set: function (value) {
            this._workflowActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "currentLanguageId", {
        get: function () {
            return this._currentLanguageId;
        },
        set: function (value) {
            this._currentLanguageId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "hasEditPermission", {
        get: function () {
            return this._hasEditPermission;
        },
        set: function (value) {
            this._hasEditPermission = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "withDeleteButton", {
        get: function () {
            return this._withDeleteButton;
        },
        set: function (value) {
            this._withDeleteButton = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "actionNotifier", {
        get: function () {
            return this._actionNotifier;
        },
        set: function (value) {
            this._actionNotifier = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderMobileComponent.prototype, "exportTemplates", {
        get: function () {
            return this._exportTemplates;
        },
        set: function (value) {
            this._exportTemplates = value;
        },
        enumerable: true,
        configurable: true
    });
    HeaderMobileComponent.prototype.ngOnInit = function () {
        var _this = this;
        var nameMeasure$ = this._classifierService.getEntityName(this.categoryName, this.entity);
        var title$ = this.title_msg
            ? of_1.of(this.title_msg)
            : this._kbService
                .getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(this.categoryName))
                .pipe(operators_1.map(function (metaCategory) {
                return metaCategory.getDisplayNameMsgId();
            }), operators_1.mergeMap(function (msg) {
                return _this._messageService.getMessage(msg);
            }));
        zip_1.zip(title$, nameMeasure$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            var title = data[0];
            var nameMeasure = data[1];
            if (title) {
                _this._title = nameMeasure
                    ? title + (" : " + nameMeasure)
                    : title;
            }
        }, function (err) { return console.error(err); });
    };
    HeaderMobileComponent.prototype.onMenuClicked = function () {
        this._eventBase.publish('de-header-menu-clicked', true);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], HeaderMobileComponent.prototype, "id", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity),
        __metadata("design:paramtypes", [idm_de_core_frontend_1.Entity])
    ], HeaderMobileComponent.prototype, "entity", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], HeaderMobileComponent.prototype, "categoryName", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], HeaderMobileComponent.prototype, "title_msg", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], HeaderMobileComponent.prototype, "isView", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderMobileComponent.prototype, "userHelpItems", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderMobileComponent.prototype, "userHelpItemsAsObjects", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderMobileComponent.prototype, "workflowActions", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], HeaderMobileComponent.prototype, "currentLanguageId", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], HeaderMobileComponent.prototype, "hasEditPermission", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], HeaderMobileComponent.prototype, "withDeleteButton", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Observable_1.Observable),
        __metadata("design:paramtypes", [Observable_1.Observable])
    ], HeaderMobileComponent.prototype, "actionNotifier", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderMobileComponent.prototype, "isReadonly", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], HeaderMobileComponent.prototype, "exportTemplates", null);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderMobileComponent.prototype, "onWfSelectEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderMobileComponent.prototype, "editClickEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderMobileComponent.prototype, "cancelEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], HeaderMobileComponent.prototype, "saveCloseEvent", void 0);
    HeaderMobileComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'header-mobile',
            template: require('./header-mobile.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "\n      <header-mobile [id]=\"'%{id}'\" [entity]=\"entity\" [categoryName]=\"category\" [isView]=\"actions.isViewForm()\"\n                      [userHelpItemsAsObjects]=\"%{userHelpItems}\"\n                      [workflowActions]=\"workflowActions\" [currentLanguageId]=\"currentLanguageId\"\n                      [title_msg]=\"%{title_msg}\" [withDeleteButton]=\"%{withDeleteButton}\" [actionNotifier]=\"actionNotifier\"\n                      [hasEditPermission]=\"%{hasEditPermission}\" (onWfSelectEvent)=\"%{onWfSelect}\"\n                      [isReadonly]=\"%{isReadonly}\"\n                      (editClickEvent)=\"%{editClick}\" (cancelEvent)=\"%{cancelEvent}\" (saveCloseEvent)=\"%{saveCloseEvent}\">\n      </header-mobile>\n    ",
            isHeader: true,
            defaultActions: {
                hasEditPermission: 'hasEditPermission',
                onWfSelect: 'onDoWorkflowAction',
                editClick: 'toDefaultEditForm',
                cancelEvent: 'onCancel',
                saveCloseEvent: 'onSaveAndClose',
            },
            name: 'Mobile Header',
            nameKey: 'de.controls.mobile_header.title',
        }),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.MessageService,
            idm_session_data_provider_api_js_1.EventBase])
    ], HeaderMobileComponent);
    return HeaderMobileComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HeaderMobileComponent = HeaderMobileComponent;
//# sourceMappingURL=header-mobile.component.js.map